module.exports = __webpack_public_path__ + "media/npc_dota_hero_warlock.e40ab61c.webm";